import { render, staticRenderFns } from "./CrushList.vue?vue&type=template&id=0c7032a4&scoped=true"
import script from "./CrushList.vue?vue&type=script&lang=js"
export * from "./CrushList.vue?vue&type=script&lang=js"
import style0 from "./CrushList.vue?vue&type=style&index=0&id=0c7032a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7032a4",
  null
  
)

export default component.exports